import { generateAlertText } from 'utils/alertHelpers';
import { ALERT_TYPES } from 'utils/constants';

export const transformAuthorizedCompany = (data) => {
    return Object.values(
        data.reduce((obj, el) => {
            const modifiedAuthorizedCompany = {
                ...el,
                id: el.authorizedOrganization.id,
                timestamp: `${el.created.slice(0, 10)} ${el.created.slice(11, 16)}`,
                phoneNumber: el.phoneNumber,
                email: el.email,
                name: el.authorizedOrganization.name,
                clientType: el.authorizedOrganization?.clientType,
                commonName: el.authorizedOrganization?.commonName,
                industryType: el.authorizedOrganization?.industryType,
                position: el.authorizedOrganization?.position,
                address: el.authorizedOrganization?.address,
                alerts: !!el.authType?.color,
                authorizedBy: '',
                authorizedByInfo: el.authorizedBy,
                note: el.note || '',
                authTypes: [],
                organization: el.organization ?? el.location?.organization,
                accessPoint: el.monitoringObject?.id,
                type: el.type,
            };

            const updatedAuthType = {
                ...modifiedAuthorizedCompany.authType,
                authTypeId: el.id,
                authorizedBy: modifiedAuthorizedCompany.authorizedByInfo,
                note: modifiedAuthorizedCompany.note,
                modified: modifiedAuthorizedCompany.modified,
                limitedPeriodAccess: {
                    accessType: el.accessType,
                    startTime: el.startTime,
                    endTime: el.endTime,
                    weekdays: el.weekdays,
                    periodType: el.periodType,
                },
            };

            modifiedAuthorizedCompany.authType = updatedAuthType;
            modifiedAuthorizedCompany.authTypes = [updatedAuthType];

            if (obj[modifiedAuthorizedCompany.id]) {
                obj[modifiedAuthorizedCompany.id].authTypes = [...obj[modifiedAuthorizedCompany.id].authTypes, updatedAuthType];
            } else {
                obj[modifiedAuthorizedCompany.id] = { ...modifiedAuthorizedCompany };
            }
            obj[modifiedAuthorizedCompany.id]?.authTypes.sort((a, b) => (a.name === ALERT_TYPES.BANNED ? -1 : b.name === ALERT_TYPES.BANNED ? 1 : 0));

            obj[modifiedAuthorizedCompany.id].alert = generateAlertText(obj[modifiedAuthorizedCompany.id].authTypes);

            return obj;
        }, {})
    );
};

export const transformPayload = (data, isUpdated) => (isUpdated ? updatePayload(data) : createPayload(data));

const createPayload = (data) => {
    return {
        organization: {
            name: data.name,
            address: data.address,
            industryType: data.industryType,
            clientType: 'NON_CLIENT',
        },
        location: {
            id: data.locationId,
        },
        email: data.email,
        relationType: data.relationType,
        phoneNumber: data.phoneNumber,
        authorizationTypes: data.authorizationTypes,
        monitoringObjectIds: data.accessPoints?.map((item) => item.value),
    };
};

const updatePayload = (data) => {
    return (data.authorizationTypes || []).map((item) => {
        return {
            ...item,
            ...{
                id: item.id,
                authorizedOrganization: {
                    id: data?.id,
                },
                location: {
                    id: data.locationId,
                },
                monitoringObjectIds: data.accessPoints?.map((item) => item.value),
                email: data.email,
                relationType: data.relationType,
                phoneNumber: data.phoneNumber,
            },
        };
    });
};
